export const Alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
] as const

export const stringToHtml = (text: string) => {
  let result = text
  // Salto de linea
  result = result.replace(/(?:\r\n|\r|\n)/g, '<br>')
  //  Bold
  result = result.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')

  return result
}

export const breakLinesFix = (text: string) => {
  return text ? text.replace(/\r?\n/g, '<br />') : text
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))

export const gbToBytes = (gb: number) => gb * 1073741824
